function copy(text) {
    return navigator.clipboard.writeText(text);
}

export { copy };
//# sourceMappingURL=clipboard.esm.js.map
